import { render, staticRenderFns } from "./AndroidHealthDetails.vue?vue&type=template&id=32c3204c&scoped=true"
import script from "./AndroidHealthDetails.vue?vue&type=script&lang=js"
export * from "./AndroidHealthDetails.vue?vue&type=script&lang=js"
import style0 from "./AndroidHealthDetails.vue?vue&type=style&index=0&id=32c3204c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c3204c",
  null
  
)

export default component.exports